import React from "react";
import Card from "../../ui/Card";
import Skeleton from "../../ui/Skeleton";

/**
 * Skeleton apenas da seção de Resultados — o formulário (Card "Extrator
 * Semântico") permanece vivo/interativo durante o loading no componente
 * real (HashtagRecommender.tsx), então este skeleton não o duplica.
 */
const HashtagRecommenderSkeleton: React.FC = () => {
  return (
    <div className="space-y-2 animate-pulse">
      <div className="flex items-center justify-between px-2">
        <div className="space-y-1">
          <Skeleton variant="text" width={140} height={20} />
          <Skeleton variant="text" width={200} height={12} />
        </div>
        <Skeleton
          variant="rectangular"
          width={110}
          height={40}
          className="rounded-lg"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <Card key={i} className="p-3 border-purple-200">
            <div className="flex items-start justify-between mb-2">
              <div className="space-y-2 flex-1">
                <Skeleton variant="text" width="60%" height={20} />
                <Skeleton
                  variant="rectangular"
                  width={80}
                  height={18}
                  className="rounded-full"
                />
              </div>
              <Skeleton
                variant="rectangular"
                width={28}
                height={28}
                className="rounded-xl"
              />
            </div>
            <div className="pt-2 border-t border-purple-200 space-y-2">
              <div className="flex justify-between items-center">
                <Skeleton variant="text" width="40%" height={10} />
                <Skeleton variant="text" width="20%" height={12} />
              </div>
              <Skeleton
                variant="rectangular"
                width="100%"
                height={6}
                className="rounded-full"
              />
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default HashtagRecommenderSkeleton;
